import axios from 'axios';

class VariantInterpretationService {

  async get_annotation_modules(onProgress, dataID, url,dataDir) {

    let formData = new FormData();
    formData.append("pid",dataID)
    formData.append("data_dir",dataDir)
    url = url + "?pid=" + dataID + "&data_dir=" + dataDir
    //alert(url)

    return await axios.get(url);

  }
  /**
  *
  *
  *
  **/
  async analyze(onProgress, dataID, url,dataDir, module, mode, genome_version, request_id = null, tumorType = null) {

    let config = {
      onUploadProgress(progressEvent) {
       var percentCompleted = Math.round((progressEvent.loaded * 100) /
         progressEvent.total);
 
       // execute the callback
       if (onProgress) onProgress(percentCompleted)
 
       return percentCompleted;
     },
    };

    let formData = new FormData();
    formData.append("id",dataID)
    formData.append("data_dir",dataDir)
    formData.append("module",module)
    formData.append("mode",mode)
    formData.append("genome_version", genome_version)

    if (request_id !== null) {
        formData.append("request_id",request_id)
    }

    url = url + "?"

    if (dataID !== undefined) {
        url = url + "id=" + dataID
    }

    if (dataDir !== undefined) {
        url = url + "&data_dir=" + dataDir
    }

    if (mode !== null) {
        url = url + "&mode=" + mode
    }

    if (request_id !== null) {
        url = url + "&request_id=" + request_id
    }
    url = url + "&module=" + module + "&genome_version=" + genome_version + "&tumor_type=" + tumorType
    //alert(url)
    //alert(localStorage.getItem("oncokbKey"))

    return await axios.get(url, formData, {
      headers: {
        "Content-Type": "application/json",
        "oncokb-key": localStorage.getItem("oncokbKey")
      },
      config
    });

    /*return await axios.post(url, formData, {
      headers: {
        "Content-Type": "application/json"
      },
      config
    });*/

  }

  getFiles() {
    return axios.get("/files");
  }

}

export default new VariantInterpretationService();
